import datetimeProvider from "../../../../../providers/datetime.provider";
import { packages } from "../../../../constant/marketing/product.constant";

const VALIDITY_NOTE = (
    <span>
        Promoção válida em{" "}
        <strong style={{ background: "#B45309", color: "#fff", fontWeight: 800, borderRadius: 5, padding: "1px 9px", whiteSpace: "nowrap" }}>10 e 11/08</strong>
    </span>
);

const GIFT_ITEM = {
    background: "#FFFBEB",
    color: "#92400E",
    text: "10% OFF já aplicado + 1 Antecipação Express grátis e 50% OFF em todas as antecipações",
};

const eventDiaAdvogado2026Config = {
    key: "diaDoAdvogado2026",
    label: "Dia do Advogado",
    initialDate: "2026-08-10",
    finalDate: "2026-08-11",
    validator: function () {
        return datetimeProvider.getDate().isBetween(this.initialDate, this.finalDate, "day", "[]");
    },
    priceTableNote: "Antecipações com 50% OFF até 11/08.",
    header: () => (
        <div className="flex justify-center mb-6">
            <div className="inline-flex items-center gap-2 rounded-full border border-amber-300 bg-amber-400/10 px-4 py-2 text-sm font-bold text-amber-200">
                <span aria-hidden="true">⚖️</span>
                Dia do Advogado: 10% OFF, 1 Express grátis e 50% nas antecipações — só 10 e 11/08
            </div>
        </div>
    ),
    additionalMessage: () => (
        <div className="text-center mt-10">
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 max-w-2xl mx-auto">
                <p className="text-sm font-medium text-amber-800">
                    ⚖️ Promoção Dia do Advogado, só em <strong>10 e 11/08</strong>: <strong>10% OFF</strong> em todos os planos,
                    {" "}<strong>1 Antecipação Express grátis</strong> de brinde e <strong>50% OFF</strong> em todas as antecipações do pacote.
                </p>
                <p className="text-xs text-amber-700 mt-2">
                    As antecipações com desconto valem enquanto durar o saldo do pacote comprado na promoção.
                </p>
            </div>
        </div>
    ),
    packages: {
        [packages.start.id]: {
            name: "Start Supremo",
            note: VALIDITY_NOTE,
            giftItem: GIFT_ITEM,
        },
        [packages.premium.id]: {
            name: "Premium Supremo",
            note: VALIDITY_NOTE,
            giftItem: GIFT_ITEM,
        },
        [packages.infinity.id]: {
            name: "Infinity Supremo",
            note: VALIDITY_NOTE,
            giftItem: GIFT_ITEM,
        },
    },
};

export default eventDiaAdvogado2026Config;
